import React from 'react'
import { SCORE_FORMAT } from '@v4/constants/result'
import Denominator from '@v4/components/common/Denominator'

// eslint-disable-next-line import/prefer-default-export
export function getFormattedScore(
	format,
	percent,
	score,
	{ withDenominator, denominatorClassName, totalPercent } = {},
) {
	if (_.isNil(score)) return null

	const typedValue = {
		[SCORE_FORMAT.PERCENTAGE]: `${percent}%`,
		[SCORE_FORMAT.SCORE]: parseFloat(score),
		[SCORE_FORMAT.DENOMINATOR_10]: withDenominator ? (
			<Denominator className={denominatorClassName} percent={percent} />
		) : (
			`${Math.floor(percent / 10)}/10`
		),
		[SCORE_FORMAT.OUT_OF_10]: `${Math.round(percent) / 10}`,
		[SCORE_FORMAT.OUT_OF_10_ROUNDED]: `${Math.floor(percent / 10)}`,
		[SCORE_FORMAT.RELATIVE_PERCENT]: `${totalPercent ? Math.round((percent * 100) / totalPercent) : 0}%`,
	}

	return typedValue[format]
}
